// Utility function to get user role from localStorage or userData
export const getUserRole = (): string => {
  const storedRole = localStorage.getItem('userRole')
  if (storedRole) {
    return storedRole
  }

  // Fallback: try to determine from userData
  try {
    const userData = localStorage.getItem('userData')
    if (userData) {
      const parsedData = JSON.parse(userData)
      if (parsedData.owner === 1) return 'owner'
      if (parsedData.role === 'org_admin' || parsedData.org_admin === 1) return 'org_admin'
      if (parsedData.role === 'recruiter' || parsedData.recruiter === 1) return 'recruiter'
      if (parsedData.role === 'support_agent' || parsedData.support_agent === 1) return 'support_agent'
      if (parsedData.role === 'analyst_viewer_org' || parsedData.analyst_viewer_org === 1) return 'analyst_viewer_org'
      if (parsedData.manager === 1) return 'manager'
      if (parsedData.team_manager === 1) return 'team_manager'
      if (parsedData.support_agent === 1) return 'support_agent'
      if (parsedData.analyst === 1) return 'analyst'
      if (parsedData.finance === 1) return 'finance'
      if (parsedData.developer === 1) return 'developer'
      if (parsedData.client_portal === 1) return 'client_portal'
      if (parsedData.recruiter === 1) return 'recruiter'
      if (parsedData.driver === 1) return 'driver'
      if (parsedData.admin === 1) return 'admin'
    }
  } catch (e) {
    console.error('Error parsing user data:', e)
  }

  return 'operator' // Default fallback
}

// Utility function to get the appropriate landing page based on user role
export const getRoleLandingPage = (): string => {
  const userRole = getUserRole()

  switch (userRole) {
    case 'recruiter':
      return '/recruiter-dashboard'
    case 'operator':
      return '/operator-dashboard'
    case 'finance':
    case 'finance-staff':
      return '/dashboard'
    case 'analyst':
    case 'analyst_viewer_org':
      return '/analyst-dashboard'
    case 'team_manager':
      return '/team-manager-dashboard'
    case 'driver':
      return '/driver-dashboard'
    case 'developer':
      return '/developer-dashboard'
    case 'client_portal':
      return '/client-portal'
    case 'owner':
    case 'admin':
    case 'manager':
    case 'org_admin':
    case 'support_agent':
      return '/dashboard'
    default:
      return '/dashboard' // Default fallback
  }
}
